import { axios } from "../../../../services/axios";
import * as CONST from "../../../constants";

const onSuccess = (dispatch, data) => {
  dispatch({ type: CONST.MERCHANT_MEAL_LIST_SUCCESS, data });
};

const onFailed = (dispatch, error) => {
  dispatch({ type: CONST.MERCHANT_MEAL_LIST_ERROR, error });
};

const handleResponse = (dispatch, response) => {
  if (response.status === 200) {
    onSuccess(dispatch, response.data.data);
  } else {
    onFailed(dispatch, response.data);
  }
};

export const merchantMealList = (merchantId) => {
  return async (dispatch) => {
    dispatch({ type: CONST.MERCHANT_MEAL_LIST_REQUEST });

    axios
      .get(`/merchants/${merchantId}/meals`)
      .then((response) => {
        handleResponse(dispatch, response);
      })
      .catch((error) => console.error(error));
  };
};
